module.exports = __webpack_public_path__ + "static/media/2_en.ba4df706.png";